import SharePointConfiguration from '../components/SharePointConfiguration';

const QmsDocumentSharePoint = () => {
  return (
    <SharePointConfiguration
      title="QMS Documents SharePoint"
      pageTitle="QMS Documents SharePoint"
      apiUrl="/v0/qms_documents/sharepoint_configuration"
      typesKey="qms_document_types"
      redirectPath="/qms_documents"
      adminRole="qms_documents_admin"
      readRole="qms_documents_readonly"
      contentTypeName="QMS Document"
      contentTypeNamePlural="QMS Documents"
      defaultLocationHelpText="All QMS documents will be uploaded to this location, unless otherwise defined by document type below."
      noTypesMessage="No QMS document types defined. (You can define QMS document types in CADM)."
    />
  );
};

export default QmsDocumentSharePoint;
